<div class="detail-page-card" [attr.data-uiid]="dataUiid">
    <div class="row">
        <div class="col-6">
            <div class="title" data-uiid="toggle-title">
                {{ title }}
            </div>
            <div
                class="description"
                data-uiid="toggle-description"
                [innerHTML]="description"
                (click)="descriptionClicked()"
            ></div>
        </div>
        <div class="col-6">
            <div
                class="toggle-container"
                data-uiid="toggle-switch"
                [class.on]="value"
                (click)="toggleSwitch()"
            >
                <div class="toggle-button"></div>
                <div
                    class="toggle-text"
                    [class]="value ? 'on' : 'off'"
                    data-uiid="toggle-switch-text"
                >
                    {{ value ? "on" : "off" }}
                </div>
            </div>
        </div>
    </div>
    @if (toggleInfo && toggleInfo.length) {
        <div class="row toggle-info">
            <div class="col-12" data-uiid="toggle-info-text">
                {{ toggleInfo }}
            </div>
        </div>
    }
</div>
